
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/what-we-buy/platinum-buyers/sell-platinum-ring",
      function () {
        return require("private-next-pages/what-we-buy/platinum-buyers/sell-platinum-ring/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/what-we-buy/platinum-buyers/sell-platinum-ring"])
      });
    }
  